const typographyModalCloneEquipModel = {
  text: 'Clonar'
};

export default typographyModalCloneEquipModel;
